const abbreviateText = (text: string, MAX_LENGTH: number): string => {
  if (text && text.length > MAX_LENGTH) {
    return text.substring(0, MAX_LENGTH - 3) + '...';
  } else {
    return text;
  }
};

export default abbreviateText;
